import produce from "immer";
import createHook from "zustand";
import createStore, { SetState } from "zustand/vanilla";
import { MenuIds } from "../types/menu.types";

export type MenuStoreType = {
  isVisible: { [id: string]: boolean };
  openMenu: (id: MenuIds) => void;
  closeMenu: (id: MenuIds) => void;
  toggleMenu: (id: MenuIds) => void;
};

export const useStore = createStore<MenuStoreType>(
  (set: SetState<MenuStoreType>) => ({
    isVisible: {},

    openMenu: (id: MenuIds): void => {
      set(
        produce((state) => {
          state.isVisible[id] = true;
        })
      );
    },
    closeMenu: (id: MenuIds): void => {
      set(
        produce((state) => {
          state.isVisible[id] = false;
        })
      );
    },
    toggleMenu: (id: MenuIds): void => {
      set(
        produce(({ isVisible }) => ({ isVisible: { [id]: !isVisible[id] } }))
      );
    },
  })
);

const useMenuStore = createHook(useStore);

/**
 * Use the below in a React Component
 * const { isVisible, openMenu, closeMenu, toggleMenu } = useMenu(MenuIds.CREATE_APP_BUILD)
 */
export const useMenu = (id: MenuIds) => {
  return {
    isVisible: useMenuStore((store) => store.isVisible[id]),
    openMenu: useMenuStore((store) => () => store.openMenu(id)),
    closeMenu: useMenuStore((store) => () => store.closeMenu(id)),
    toggleMenu: useMenuStore((store) => () => store.toggleMenu(id)),
  };
};
